module.exports = __webpack_public_path__ + "static/media/entrepreneurshipImg.9766e76d.svg";